import { useAuth0 } from "@auth0/auth0-react";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Modal,
  Slider,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import React from "react";
import { API_ENDPOINTS } from "../../../API/apiConfig";
import { DataGridContext } from "../../../context/DataGridContext";
import { useUserState } from "../../../context/UserContext";
import AccessControl, { checkPermissions } from "../../AccessControl";
import WhitelistDialog from "./WhitelistDialog";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { Colours } from "../../../assets/global/Theme-variable";
import { useDispatch } from "react-redux";
import { toggleSnackbarOpen } from "../../../redux/actions/snackbarActions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  width: 700,
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: 2,
};

export default function AdvancedSettings({
  modalVisible,
  setModalVisible,
  newChanges,
  setNewChanges,
}) {
  const { data, setData, variant, setVariant } =
    React.useContext(DataGridContext);
  const _ = require("lodash");

  const userPermission = useUserState();
  const { getAccessTokenSilently } = useAuth0();
  const [isSaving, setIsSaving] = React.useState(false);
  const [whitelistDialogOpen, setWhitelistDialogOpen] = React.useState(false);
  const [checked, setChecked] = React.useState([]);
  const [originalChecked, setOriginalChecked] = React.useState([]);
  const [listCopy, setListCopy] = React.useState();
  const [siteChanges, setSiteChanges] = React.useState([]);
  const dispatch = useDispatch();
  const [error, setError] = React.useState(false);

  const handleCancel = () => {
    setModalVisible(false);
    getChecked();
  };

  const getChecked = () => {
    if (variant !== undefined && variant?.list_number) {
      const checked =
        variant?.list_variant === 0 &&
        !variant?.list_details?.hasOwnProperty("siteWhitelist")
          ? data?.sites
              ?.filter((site) => {
                // console.log("doesnt have own");
                return !site?.site_details?.screen_variants?.some(
                  (obj) =>
                    obj?.hasOwnProperty(parseInt(variant?.list_number)) &&
                    obj[variant?.list_number] !== variant?.list_variant
                );
              })
              ?.map((site) => parseInt(site?.site_ref))
          : variant?.list_variant === 0 &&
            variant?.list_details?.hasOwnProperty("siteWhitelist")
          ? data?.sites
              ?.filter((site) => {
                return (
                  !site?.site_details?.screen_variants?.some(
                    (obj) =>
                      obj?.hasOwnProperty(parseInt(variant?.list_number)) &&
                      obj[variant?.list_number] !== variant?.list_variant
                  ) &&
                  variant?.list_details?.siteWhitelist?.includes(
                    parseInt(site?.site_ref)
                  )
                );
              })

              ?.map((site) => parseInt(site?.site_ref))
          : data.sites
              .filter((site) =>
                site?.site_details?.screen_variants?.some(
                  (obj) =>
                    obj?.hasOwnProperty(parseInt(variant?.list_number)) &&
                    obj[variant?.list_number] === variant?.list_variant
                )
              )
              ?.map((site) => parseInt(site?.site_ref));
      setChecked(checked);

      setOriginalChecked(checked);

      setListCopy(variant);
    }
  };

  const handleRangeChange = (event, newValue) => {
    setListCopy((prev) => ({
      ...prev,
      list_details: {
        ...prev.list_details,
        selMin: newValue[0],
        selMax: newValue[1],
      },
    }));
  };

  const handleStaydown = (event) => {
    setListCopy((prev) => ({
      ...prev,
      list_details: {
        ...prev.list_details,
        staydown: event.target.checked === true ? 1 : 0,
      },
    }));
  };

  const handleIgnoreList = (event) => {
    setListCopy((prev) => ({
      ...prev,
      list_details: {
        ...prev.list_details,
        ignoreThisList: event.target.checked,
      },
    }));
  };
  React.useEffect(() => {
    getChecked();
  }, [variant]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSave = async (siteChanges) => {
    setIsSaving(true);

    const defaultScreen = data?.screens?.find(
      (screen) =>
        parseInt(screen?.list_number) === parseInt(listCopy?.list_number) &&
        screen?.list_variant === 0 &&
        screen?.list_isDeleted === 0
    );
    const allSites = [...data.sites].map((s) => parseInt(s.site_ref));
    let turnedOff = [];
    let turnedOn = [];

    originalChecked.forEach((preObj) => {
      const found = checked.find(
        (newObj) => JSON.stringify(newObj) === JSON.stringify(preObj)
      );
      if (!found) {
        turnedOff.push(preObj);
      }
    });

    checked.forEach((newObj) => {
      const found = originalChecked.find(
        (prevObj) => JSON.stringify(prevObj) === JSON.stringify(newObj)
      );
      if (!found) {
        turnedOn.push(newObj);
      }
    });

    let newMainScreenCopy = JSON.parse(
      JSON.stringify(variant.list_variant !== 0 ? defaultScreen : listCopy)
    );

    let whitelist =
      variant.list_variant === 0
        ? checked
        : newMainScreenCopy.list_details.hasOwnProperty("siteWhitelist")
        ? newMainScreenCopy.list_details.siteWhitelist
        : allSites;
    const newSites = JSON.parse(JSON.stringify(data.sites));
    function compareNumbers(a, b) {
      return a - b;
    }

    // if default screen has whitelist, use whitelist
    // const testWhitelist = data.sites
    //   .filter((site) =>
    //     site?.site_details?.screen_variants?.some(
    //       (obj) =>
    //         obj?.hasOwnProperty(parseInt(variant?.list_number)) &&
    //         obj[variant?.list_number] === variant?.list_variant
    //     )
    //   )
    //   ?.map((site) => parseInt(site?.site_ref));

    const sitesToUpdate = [];
    const screensToUpdate = [];

    if (variant.list_variant === 0) {
      if (
        whitelist.length === allSites.length &&
        _.isEqual(compareNumbers(whitelist), compareNumbers(allSites)) &&
        Object.hasOwn(newMainScreenCopy.list_details, "siteWhitelist")
      ) {
        delete newMainScreenCopy.list_details.siteWhitelist;
      } else {
        if (!Object.hasOwn(newMainScreenCopy.list_details, "siteWhitelist")) {
          newMainScreenCopy.list_details.siteWhitelist = [];
        }
        newMainScreenCopy.list_details.siteWhitelist = whitelist;
      }

      screensToUpdate.push(newMainScreenCopy);
      data.sites.map((site) => {
        if (turnedOn.includes(parseInt(site.site_ref))) {
          site.site_details.screen_variants =
            site?.site_details?.screen_variants?.filter(
              (screen) => !screen.hasOwnProperty([listCopy.list_number])
            );
          sitesToUpdate.push(site);
          let foundIndex = newSites.findIndex(
            (x) => parseInt(x.site_ref) === parseInt(site.site_ref)
          );
          newSites[foundIndex] = site;
        }
        return site;
      });
    } else {
      screensToUpdate.push(listCopy);

      if (siteChanges?.length > 0) {
        function filterWhitelist(whitelist, siteChanges) {
          const siteRefsToRemove = siteChanges
            .filter((change) => change.screen === "Whitelist")
            .map((change) => change.siteRef);

          return whitelist.filter((item) => !siteRefsToRemove.includes(item));
        }

        newMainScreenCopy.list_details.siteWhitelist = filterWhitelist(
          whitelist,
          siteChanges
        );

        if (
          Object.hasOwn(newMainScreenCopy?.list_details, "siteWhitelist") &&
          newMainScreenCopy?.list_details?.siteWhitelist?.length ===
            allSites.length &&
          _.isEqual(
            newMainScreenCopy?.list_details?.siteWhitelist?.sort(),
            allSites.sort()
          )
        ) {
          delete newMainScreenCopy?.list_details?.siteWhitelist;
        }
        screensToUpdate.push(newMainScreenCopy);
      } else {
        turnedOn.map((s) => !whitelist.includes(s) && whitelist.push(s));
        if (
          whitelist.length === allSites.length &&
          _.isEqual(whitelist.sort(), allSites.sort()) &&
          Object.hasOwn(newMainScreenCopy.list_details, "siteWhitelist")
        ) {
          delete newMainScreenCopy.list_details.siteWhitelist;
        } else {
          if (!Object.hasOwn(newMainScreenCopy.list_details, "siteWhitelist")) {
            newMainScreenCopy.list_details.siteWhitelist = [];
          }
          newMainScreenCopy.list_details.siteWhitelist = whitelist.filter(
            (x) => !turnedOff.includes(x)
          );
        }

        if (
          Object.hasOwn(newMainScreenCopy.list_details, "siteWhitelist") &&
          newMainScreenCopy?.list_details?.siteWhitelist?.length ===
            allSites.length &&
          _.isEqual(
            newMainScreenCopy?.list_details?.siteWhitelist?.sort(),
            allSites.sort()
          )
        ) {
          delete newMainScreenCopy?.list_details?.siteWhitelist;
        }
        screensToUpdate.push(newMainScreenCopy);
      }

      data.sites.map((site) => {
        if (turnedOn.includes(parseInt(site.site_ref))) {
          const variantObj = new Map([
            [listCopy.list_number, listCopy.list_variant],
          ]);
          const obj = Object.fromEntries(variantObj);
          site.site_details.screen_variants =
          site?.site_details?.screen_variants ? site?.site_details.screen_variants?.filter(
              (screen) => !screen.hasOwnProperty([variant.list_number])
            ) : [];

          site.site_details.screen_variants.push(obj);
          sitesToUpdate.push(site);
          let foundIndex = newSites.findIndex(
            (x) => parseInt(x.site_ref) === parseInt(site.site_ref)
          );
          newSites[foundIndex] = site;
        }
        if (turnedOff.includes(parseInt(site.site_ref))) {
          site.site_details.screen_variants =
          site?.site_details?.screen_variants ? site?.site_details?.screen_variants.filter(
              (screen) =>
                !screen.hasOwnProperty([newMainScreenCopy.list_number])
            ): [];
          sitesToUpdate.push(site);
          let foundIndex = newSites.findIndex(
            (x) => parseInt(x.site_ref) === parseInt(site.site_ref)
          );
          newSites[foundIndex] = site;
        }
        return site;
      });
    }
    const token = await getAccessTokenSilently();

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const newRowData = {
      updates: screensToUpdate,
    };
    let postSuccess = true;
    axios
      .post(API_ENDPOINTS.list, newRowData, config) // using endpoint from config
      .then(function (response) {
        // console.log("res list, list copy", response.data.list, listCopy);
        // setTimeout(() => {
        const newScreens = [...data.screens];

        if (listCopy.list_variant !== 0) {
          const newVariant = response?.data?.list?.find(
            (i) => i?.list_variant === listCopy?.list_variant
          );
          newVariant.uid = newVariant.list_uid;
          const foundIndex = newScreens.findIndex(
            (x) => parseInt(x.list_uid) === parseInt(listCopy?.uid)
          );
          newScreens[foundIndex] = newVariant;
          const newMainScreen = response?.data?.list?.find(
            (i) => i?.list_variant === 0
          );
          newMainScreen.uid = newMainScreen?.list_uid;
          const mainScreenIndex = newScreens.findIndex(
            (x) => parseInt(x?.list_uid) === parseInt(defaultScreen?.uid)
          );

          newScreens[mainScreenIndex] = newMainScreen;
          setData({ ...data, screens: newScreens });
          setVariant(newVariant);
        } else {
          const newMainScreen = response.data.list?.find(
            (i) => i?.list_variant === 0
          );
          newMainScreen.uid = newMainScreen.list_uid;

          const mainScreenIndex = newScreens.findIndex(
            (x) => parseInt(x?.list_uid) === parseInt(defaultScreen?.list_uid)
          );
          newScreens[mainScreenIndex] = newMainScreen;
          setData({ ...data, screens: newScreens });

          setVariant(newMainScreen);
        }
        // }, 1000);
      })
      .catch(function (error) {
        postSuccess = false;
        console.log("res", error);
      });

    const siteUpdate = {
      updates: Array.isArray(sitesToUpdate) ? sitesToUpdate : [sitesToUpdate],
    };

    // console.log(originalChecked, sitesToUpdate, data.sites, listCopy);
    // if (siteUpdate.updates.length > 0) {
    //   // console.log("doing this");
    //   axios
    //     .post(API_ENDPOINTS.site, siteUpdate, config)
    //     .then(function (response) {
    //       console.log("res", response);
    //       setTimeout(() => {
    //         // console.log("in here");
    //         setIsSaving(false);
    //         setModalVisible(false);
    //         // setOriginalChecked(checked);
    //         // console.log(newSites);
    //         setData({ ...data, sites: newSites });
    //         setWhitelistDialogOpen(false);
    //       }, 1000);
    //     })
    //     .catch(function (error) {
    //       console.log("res", error);
    //       postSuccess = false;
    //       // setChecked(originalChecked);
    //       // console.log(listCopy);
    //       setIsSaving(false);
    //       setError(true);
    //       dispatch(
    //         toggleSnackbarOpen({
    //           message: `ERROR couldn't save site updates to server. ${error?.response?.statusText}.`,
    //           duration: 2000,
    //           severity: "error",
    //           open: true,
    //         })
    //       );
    //       // getChecked();
    //       // console.log("error", originalChecked, checked, turnedOn, turnedOff);
    //     });
    // } else {
    //   // console.log("doing this 2");
    //   if (postSuccess === true) {
    //     console.log("no error");
    //     setTimeout(() => {
    //       setIsSaving(false);
    //       setModalVisible(false);
    //       // dispatch(
    //       //   toggleSnackbarOpen({
    //       //     message: "Changes Saved Successfully",
    //       //     duration: 2000,
    //       //     severity: "success",
    //       //     open: true,
    //       //   })
    //       // );

    //       setNewChanges(false);
    //     }, 1000);
    //   } else {
    //     console.log("else");
    //     setIsSaving(false);
    //     setError(true);
    //     dispatch(
    //       toggleSnackbarOpen({
    //         message: `ERROR couldn't save site updates to server. ${error?.response?.statusText}.`,
    //         duration: 2000,
    //         severity: "error",
    //         open: true,
    //       })
    //     );
    //     // console.log("error", originalChecked);
    //     setChecked(originalChecked);
    //   }
    // }

    if (siteUpdate.updates.length > 0) {
      axios
        .post(API_ENDPOINTS.site, siteUpdate, config) // using endpoint from config
        .then(function (response) {
          setTimeout(() => {
            setIsSaving(false);
            setModalVisible(false);
            setOriginalChecked(checked);
            setData({ ...data, sites: newSites });
            setWhitelistDialogOpen(false);
          }, 1000);
        })
        .catch(function (error) {
          console.log("res", error);
          setIsSaving(false);
        });
    } else {
      setTimeout(() => {
        setIsSaving(false);
        setModalVisible(false);
      }, 1000);
    }
    // };
  };

  const handleSave2 = () => {
    const intersection = originalChecked.filter((x) => !checked.includes(x));
    const arr = [];
    if (variant.list_variant !== 0) {
      intersection.map((siteref) =>
        arr.push({ siteRef: siteref, screen: "Whitelist" })
      );
    }

    if (
      (checked.length === originalChecked.length &&
        checked.every(function (value, index) {
          return value === originalChecked[index];
        })) ||
      variant.list_variant === 0 ||
      arr.length === 0
    ) {
      handleSave();
    } else {
      setSiteChanges(arr);
      setWhitelistDialogOpen(true);
    }
  };

  return (
    <>
      {WhitelistDialog({
        whitelistDialogOpen,
        setWhitelistDialogOpen,
        variant,
        handleSave,
        siteChanges,
        setSiteChanges,
      })}
      <Modal
        open={modalVisible}
        onClose={() => handleCancel()}
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h3">Advanced Settings</Typography>
            <Button
              variant="contained"
              size="medium"
              sx={{ alignSelf: "flex-end" }}
              onClick={() => handleCancel()}
            >
              X
            </Button>
          </Box>
          {/* <OptionSelect
					// option={
					// 	listArea === "Bottom Bar"
					// 		? bottomLayout
					// 		: // : listArea === "Standard List"
					// 		  // ? standardListLayout
					// 		  layout
					// }
					options={[1, 2, 3, 4]}
					value={stayDown}
					type="staydown"
					label={"Stay Down"}
					onChange={(event) => setStayDown(event.target.value)}
					// width="10%"
				/> */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 10,
              height: 60,
            }}
          >
            <FormControlLabel
              // value={variant.list_details.stayDown === 1 ? true : false}
              control={
                <Checkbox
                  // disabled={checkPermissions(userPermission, {
                  // 	page: "lists",
                  // 	allow: false,
                  // 	action: "edit",
                  // })}
                  checked={
                    listCopy?.list_details?.staydown === 1 ? true : false
                  }
                  onChange={handleStaydown}
                  inputProps={{ "aria-label": "show text" }}
                  disableRipple
                  sx={{
                    "& .label": {
                      marginLeft: 0,
                    },
                    // justifySelf: "flex-end",
                    // MuiButtonBase-root-MuiCheckbox-root
                    "& .MuiCheckbox": {
                      padding: 0,
                    },
                    "& .MuiButtonBase-root": {
                      padding: 0,
                    },
                    p: 0,
                  }}
                  size="small"
                  disabled={
                    !checkPermissions(userPermission, {
                      page: "screens",
                      strict: false,
                      action: "edit",
                    })
                  }
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: 15,
                    // marginLeft: 0,
                    "& .MuiFormControlLabel-root MuiFormControlLabel-labelPlacementStart":
                      {
                        // marginLeft: 0,
                      },
                  }}
                >
                  Staydown
                </Typography>
              }
              labelPlacement="top"
              sx={{
                margin: 0,
                // alignItems: "flex-start",
              }}
            />
            <Box
              sx={{
                width: "auto",
                display: "flex",
                flex: 1,
                flexDirection: "column",
                // alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{ fontSize: 15, textAlign: "center" }}
                id="input-slider"
              >
                Number of Items
              </Typography>
              <Stack
                spacing={2}
                direction="row"
                sx={{ width: "100%" }}
                alignItems="center"
              >
                <Typography
                  sx={{ fontSize: 12, textAlign: "center", lineHeight: 1 }}
                >
                  {listCopy?.list_details?.selMin} min
                </Typography>
                <Slider
                  getAriaLabel={() => "Item selection range"}
                  value={[
                    listCopy?.list_details?.selMin,
                    listCopy?.list_details?.selMax,
                  ]}
                  onChange={handleRangeChange}
                  disabled={
                    !checkPermissions(userPermission, {
                      page: "screens",
                      strict: false,
                      action: "edit",
                    })
                  }
                  min={0}
                  max={10}
                  sx={{
                    "& .MuiSlider-thumb": {
                      height: 15,
                      width: 15,
                      // backgroundColor: "pink",
                    },
                  }}
                />
                <Typography
                  sx={{ fontSize: 12, textAlign: "center", lineHeight: 1 }}
                >
                  {listCopy?.list_details?.selMax} max
                </Typography>
              </Stack>
            </Box>
            {/* <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                // alignItems: "flex-start",
                justifyContent: "center",
              }}
            > */}
            {checkPermissions(userPermission, {
              page: "*",
              api: "GSAdmin",
              action: "*",
              strict: true,
            }) === true && (
              <FormControlLabel
                // value={variant.list_details.stayDown === 1 ? true : false}
                control={
                  <Checkbox
                    // disabled={checkPermissions(userPermission, {
                    // 	page: "lists",
                    // 	allow: false,
                    // 	action: "edit",
                    // })}
                    checked={
                      listCopy?.list_details?.hasOwnProperty("ignoreThisList")
                        ? listCopy?.list_details?.ignoreThisList
                        : false
                    }
                    onChange={handleIgnoreList}
                    inputProps={{ "aria-label": "show text" }}
                    disableRipple
                    sx={{
                      "& .label": {
                        // marginLeft: 0,
                      },
                      // justifySelf: "flex-end",
                      // MuiButtonBase-root-MuiCheckbox-root
                      "& .MuiCheckbox": {
                        padding: 0,
                      },
                      "& .MuiButtonBase-root": {
                        padding: 0,
                      },
                      p: 0,
                    }}
                    size="small"
                    disabled={
                      !checkPermissions(userPermission, {
                        page: "screens",
                        strict: false,
                        action: "edit",
                      })
                    }
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: 15,
                      // marginLeft: 0,
                      "& .MuiFormControlLabel-root MuiFormControlLabel-labelPlacementStart":
                        {
                          // marginLeft: 0,
                        },
                    }}
                  >
                    Disable sending to till
                  </Typography>
                }
                labelPlacement="top"
                sx={{
                  margin: 0,
                  // alignItems: "flex-start",
                }}
              />
            )}
            {/* </Box> */}
          </Box>
          <Box sx={{ width: "100%", height: "100%", mt: 2 }}>
            <Typography
              sx={{ fontSize: 15, fontWeight: 400, textAlign: "center" }}
              id="input-slider"
            >
              Sites
            </Typography>
            <List
              sx={{
                width: "100%",

                columnCount: 3,
                // columnGap: 4,

                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {data?.sites?.map((site) => (
                <ListItem sx={{ p: 1 }} key={site?.site_ref}>
                  <FormControlLabel
                    control={
                      <Switch
                        edge="start"
                        onChange={handleToggle(parseInt(site?.site_ref))}
                        checked={
                          checked?.indexOf(parseInt(site?.site_ref)) !== -1
                        }
                        inputProps={{
                          "aria-labelledby": "switch-list-label-site",
                        }}
                        size="small"
                        disabled={
                          // variant?.list_variant === 0 ||

                          checkPermissions(userPermission, {
                            page: "screens",
                            strict: false,
                            action: "edit",
                          }) === false &&
                          data?.screens
                            ?.find(
                              (screen) =>
                                screen.list_number === variant.list_number &&
                                screen.list_isDeleted === 0 &&
                                screen.list_variant === 0
                            )
                            ?.siteWhitelist.indexOf(parseInt(site.site_ref)) ===
                            -1
                        }
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: 13 }}>
                        {site?.site_name}
                      </Typography>
                    }
                    sx={{
                      p: 0,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  />
                  {variant?.list_variant === 0 &&
                    variant?.list_details?.siteWhitelist?.indexOf(
                      parseInt(site?.site_ref)
                    ) === -1 && (
                      <Tooltip title="This screen is not being sent to this site">
                        <InfoOutlineIcon
                          style={{
                            color: Colours.gsblue,
                          }}
                        />
                      </Tooltip>
                    )}
                </ListItem>
              ))}
            </List>
          </Box>
          <AccessControl
            userPermissions={userPermission}
            unallowedPermissions={{
              page: "screens",
              // allow: false,
              strict: false,

              action: "edit",
            }}
            // renderNoAccess={() => <NoAccess permissionsNeeded="read:stats" />}
            renderNoAccess={() => <></>}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                justifySelf: "flex-end",
              }}
            >
              <Button
                variant="outlined"
                size="medium"
                sx={{ alignSelf: "flex-end" }}
                onClick={() => handleCancel()}
              >
                Cancel
              </Button>
              <LoadingButton
                size="small"
                onClick={handleSave2}
                loading={isSaving}
                variant={!isSaving ? "contained" : "outlined"}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                disabled={isSaving}
              >
                <span>Save</span>
              </LoadingButton>
            </Box>
          </AccessControl>
        </Box>
      </Modal>
    </>
  );
}
